import { render } from "./ModalIdle.vue?vue&type=template&id=635482a5&scoped=true"
import script from "./ModalIdle.vue?vue&type=script&lang=js"
export * from "./ModalIdle.vue?vue&type=script&lang=js"

import "./ModalIdle.vue?vue&type=style&index=0&id=635482a5&lang=postcss&scoped=true"

import exportComponent from "D:\\ARCHIVOS\\PROYECCION SERVIDOR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635482a5"]])

export default __exports__